import Vue from 'vue'
import App from './App.vue'
import { Loading } from 'vant'
import weixin from 'weixin-js-sdk'
import router from './router'
import store from './store'
// import wxJsSdk from '@/utils/wxJsSdk'
import './router/before'
import DrComponents from '@/components'
import i18n from './lang'
import './styles/base/reset.css'
import { Overlay, Dialog } from 'vant'
import './styles/mixins.scss'
// rem适配
import 'amfe-flexible'
// 300毫秒延迟
// import attachFastClick from 'fastclick'
import axiosFun from './utils/request'
import handleWxConfig from '@/App'
if ('addEventListener' in document) {
  document.addEventListener('DOMContentLoaded', function() {
    // attachFastClick.attach(document.body)
  }, false)
}
// import VConsole from 'vconsole'
import VueResource from 'vue-resource'
import { Uploader } from 'vant'
import { ImagePreview } from 'vant'
import { Icon } from 'vant'

Vue.use(ImagePreview)
Vue.use(Uploader)
Vue.use(Dialog)
Vue.use(VueResource)
Vue.use(Overlay)
// new VConsole()
Vue.config.productionTip = false
Vue.use(DrComponents)
Vue.use(Loading)
Vue.use(Icon)
Vue.prototype.$api = axiosFun
Vue.prototype.$wxConfig = handleWxConfig
window.wx = weixin
import VueImageSwipe from 'vue-image-swipe'
import 'vue-image-swipe/dist/vue-image-swipe.css'
Vue.use(VueImageSwipe)
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
